<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <div class="config-container">
        <div class="config-form">
          <el-form ref="missionForm"
                   :model="form"
                   :rules="newbieMissionConfigRules"
                   size="small"
                   label-width="160px">

            <el-form-item label="启用状态"
                          prop="is_newbie_mission_enable">
              <el-switch v-model="form.is_newbie_mission_enable"
                         active-text="启用"
                         inactive-text="停用">
              </el-switch>
              <span style="margin-left: 10px;">关闭后，后续注册的用户不再展示新手引导弹窗，弹出过的用户会继续走完流程</span>
            </el-form-item>

            <el-form-item label="总开关"
                          prop="is_show_mission_dialog">
              <el-switch v-model="form.is_show_mission_dialog"
                         active-text="启用"
                         inactive-text="停用">
              </el-switch>
              <span style="margin-left: 10px;">关闭后，线上所有用户都不展示新手引导弹窗，包括正在进行中的用户</span>
            </el-form-item>

            <el-form-item label="新手教程视频"
                          prop="watch_tutorial_video.video_url">
              <div v-if="form.watch_tutorial_video.video_url"
                   class="video-preview">
                <video :src="form.watch_tutorial_video.video_url"
                       controls
                       width="400"
                       height="225"></video>
                <el-button type="text"
                           icon="el-icon-delete"
                           @click="handleVideoRemove"
                           style="margin-left: 10px;">删除视频重新上传
                </el-button>
              </div>
              <el-upload v-else
                         class="upload-demo"
                         :http-request="handleVideoUpload"
                         :file-list="videoFileList"
                         accept=".mp4"
                         :limit="1"
                         action="#">
                <el-button size="small"
                           type="primary">点击上传
                </el-button>
                <div slot="tip"
                     class="el-upload__tip">只能上传MP4视频文件，且不超过200MB
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="新手教程视频封面"
                          prop="watch_tutorial_video.img_url">
              <div v-if="form.watch_tutorial_video.img_url"
                   class="img-preview">
                <img :src="form.watch_tutorial_video.img_url"
                     width="400"
                     alt="视频封面">
                <el-button type="text"
                           icon="el-icon-delete"
                           @click="handleImageRemove"
                           style="margin-left: 10px;">删除封面重新上传
                </el-button>
              </div>
              <el-upload v-else
                         class="upload-demo"
                         :http-request="handleImageUpload"
                         :file-list="imgFileList"
                         accept="image/*"
                         :limit="1"
                         action="#">
                <el-button size="small"
                           type="primary">点击上传
                </el-button>
                <div slot="tip"
                     class="el-upload__tip">只能上传图片文件，建议尺寸与视频比例一致
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="选择新手任务"
                          prop="finish_newbie_task.task_id">
              <remote-select class="width-max"
                             clearable
                             id-key="taskid"
                             label-key="title"
                             value-key="taskid"
                             placeholder="输入任务名称搜索"
                             @change="onTaskChange"
                             v-model="form.finish_newbie_task.task_id"
                             :findParams="{id: form.finish_newbie_task.task_id}"
                             :query-request="queryTaskTableWithCache"
                             :find-request="getTaskDetail">
              </remote-select>
            </el-form-item>

            <el-form-item>
              <el-button type="success"
                         size="small"
                         :loading="isSaving"
                         @click="onSubmit">保存配置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { newbieMissionConfigRules } from '../users.rules'
import { adminDirectUploadFilesApi } from '../users.api.js'

export default {
  data () {
    return {
      isSaving: false,
      newbieMissionConfigRules,
      form: {
        is_show_mission_dialog: true,
        is_newbie_mission_enable: true,
        watch_tutorial_video: {
          video_url: '',
          img_url: '',
        },
        finish_newbie_task: {
          task_id: '',
          task_title: '',
          salary: '',
        },
      },
      videoFileList: [],
      imgFileList: [],
      taskCache: {},
    }
  },
  computed: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  methods: {
    ...request.map(['getTaskDetail']),
    onLoad () {
      this.getConfig()
    },
    onTaskChange () {
      this.form.finish_newbie_task.task_title = ''
      this.form.finish_newbie_task.salary = ''

      const taskId = this.form.finish_newbie_task.task_id
      if (this.taskCache[taskId]) {
        this.form.finish_newbie_task.task_title = this.taskCache[taskId].task_title
        this.form.finish_newbie_task.salary = this.taskCache[taskId].salary
      }
    },
    queryTaskTableWithCache (params) {
      return request.common('queryTaskTable', params).then((res) => {
        res.data.data.forEach((item) => {
          this.taskCache[item.taskid] = {
            task_id: item.taskid + '',
            task_title: item.title,
            salary: item.salary + '',
          }
        })
        return res
      })
    },
    getConfig () {
      const initLoading = this.$loading({ text: '配置拉取中...', lock: true })
      request.common('getNewbieMissionCfgApi', {}).then(({data}) => {
        if (data && data.value && !_.isEmpty(data.value)) {
          const config = data.value
          const missionCfg = _.get(config, 'newbie_mission_config', {})
          const tutorialVideo = missionCfg.watch_tutorial_video || {}
          const newbieTask = missionCfg.finish_newbie_task || {}

          this.form.is_show_mission_dialog = _.get(config, 'is_show_mission_dialog', false)
          this.form.is_newbie_mission_enable = _.get(config, 'is_newbie_mission_enable', true)
          this.form.watch_tutorial_video = {...this.form.watch_tutorial_video, ...tutorialVideo}
          this.form.finish_newbie_task = {...this.form.finish_newbie_task, ...newbieTask}

          // 把当前回流的任务数据压入缓存池作为安全种子，防止被 remote-select 初始回显误清空
          if (newbieTask.task_id) {
            this.taskCache[newbieTask.task_id] = {...newbieTask}
          }
        }
      }).catch(() => {
        this.$message.error('配置拉取失败，请刷新页面重试')
      }).finally(() => {
        initLoading.close()
      })
    },
    onSubmit () {
      if (!filter.hasPermission(20002)) {
        this.$alert('您没有保存 新手任务配置 的权限')
        return
      }

      this.$refs.missionForm.validate((valid, invalidFields) => {
        if (valid) {
          this.saveConfig()
        } else {
          const messages = Object.values(invalidFields || {})
            .map(errors => errors.map(e => e.message).join('；'))
            .join('；')
          this.$message.error('表单填写不正确：' + messages)
        }
      })
    },
    saveConfig () {
      const params = {
        is_show_mission_dialog: this.form.is_show_mission_dialog,
        is_newbie_mission_enable: this.form.is_newbie_mission_enable,
        newbie_mission_config: {
          watch_tutorial_video: this.form.watch_tutorial_video,
          finish_newbie_task: this.form.finish_newbie_task,
        },
      }
      this.isSaving = true
      request.common('setNewbieMissionCfgApi', params).then(() => {
        this.$alert('配置保存成功')
      }).catch(() => {
        this.$message.error('配置保存失败')
      }).finally(() => {
        this.isSaving = false
      })
    },
    async handleVideoUpload (options) {
      const file = options.file
      const fileType = file.type
      const fileSizeMB = file.size / 1024 / 1024
      const isVideo = (fileType === 'video/mp4')

      if (!isVideo) {
        this.$message.error('只能上传MP4视频文件!')
        return Promise.reject(new Error('只能上传MP4视频文件!'))
      }
      if (fileSizeMB > 200) {
        this.$message.error('视频大小不能超过200MB!')
        return Promise.reject(new Error('视频大小不能超过200MB!'))
      }

      const uploadLoading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const videoUrl = await this.doAdminDirectUploadFile(file)
        if (videoUrl) {
          this.form.watch_tutorial_video.video_url = videoUrl
          this.videoFileList = [{name: file.name, url: videoUrl}]
          this.$message.success('视频上传成功')
        }
      } catch (error) {
        this.$message.error('视频上传失败: ' + error.message)
        return Promise.reject(error)
      } finally {
        uploadLoading.close()
      }
    },
    async doAdminDirectUploadFile (file) {
      try {
        const params = {
          file_name: file.name,
          ext: file.name.split('.').pop().toLowerCase(),
          content_type: file.type
        }
        const res = await adminDirectUploadFilesApi(params)
        if (res.data.ret === 0) {
          const uploadUrl = res.data.detail.signedUrl
          const contentType = res.data.detail.content_type
          const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({'Content-Type': contentType}),
            body: file
          })
          if (!uploadRes.ok) {
            throw new Error(`上传失败，原因: ${uploadRes.status}`)
          }
          return res.data.detail.url
        } else {
          throw new Error(res.data.msg || '上传失败')
        }
      } catch (error) {
        throw new Error(error.message || '上传失败')
      }
    },
    handleVideoRemove () {
      this.form.watch_tutorial_video.video_url = ''
      this.videoFileList = []
    },
    async handleImageUpload (options) {
      const file = options.file
      const fileType = file.type
      const fileSizeMB = file.size / 1024 / 1024
      const isImage = fileType.startsWith('image/')

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return Promise.reject(new Error('只能上传图片文件!'))
      }
      if (fileSizeMB > 10) {
        this.$message.error('图片大小不能超过10MB!')
        return Promise.reject(new Error('图片大小不能超过10MB!'))
      }

      const uploadLoading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const imgUrl = await this.doAdminDirectUploadFile(file)
        if (imgUrl) {
          this.form.watch_tutorial_video.img_url = imgUrl
          this.imgFileList = [{name: file.name, url: imgUrl}]
          this.$message.success('封面上传成功')
        }
      } catch (error) {
        this.$message.error('封面上传失败: ' + error.message)
        return Promise.reject(error)
      } finally {
        uploadLoading.close()
      }
    },
    handleImageRemove () {
      this.form.watch_tutorial_video.img_url = ''
      this.imgFileList = []
    },
  }
}
</script>

<style lang="scss"
       scoped>
.config-container {
  padding: 10px 20px;

  .config-form {
    max-width: 800px;
  }

  .video-preview {
    display: flex;
    align-items: flex-start;

    video {
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background-color: #F5F7FA;
    }
  }

  .img-preview {
    display: flex;
    align-items: flex-start;

    img {
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background-color: #F5F7FA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/users/pages/NewbieMissionCfg.vue